import { Field, Form, Formik } from 'formik';
import React, { useState, useEffect, useCallback } from 'react';
import { Link } from "react-router-dom";
import withRouter from "../../withRouter.js";
import { userid, currentTenant, currency } from '../../Common/Credentials.js';
import InventoryService from '../../inventory/InventoryService.js';
import { Autocomplete, Backdrop, CircularProgress } from '@mui/material';
import Swal from 'sweetalert2';
import Breadcrumb from '../../NewUI/NewComponents/Breadcrumb.jsx';
import TextfieldComponent from '../../Component/TextfieldComponent.jsx';

const AddCost = ({ navigate, location }) => {
  const [loader, setLoader] = useState(false);
  const [itemsList, setItemsList] = useState([]);
  const [name, setName] = useState('');
  const [cost, setCost] = useState('');
  const [uom, setUom] = useState('');
  const [filterlist, setFilterlist] = useState('');
  const [hovered, setHovered] = useState(null);

  const pagename = location.state?.pagename || '';
  const id = location.state?.id || '';

  // Modern styling similar to NewItem.jsx
  const styles = {
    formGroup: {
      marginBottom: '16px',
    },
    label: {
      display: 'block',
      fontSize: '0.75rem',
      fontWeight: 600,
      color: '#1e293b',
      textTransform: 'uppercase',
      letterSpacing: '0.05em',
      marginBottom: '4px',
    },
    input: {
      width: '100%',
      padding: '8px 12px',
      border: '1px solid #d1d5db',
      borderRadius: '6px',
      fontSize: '0.8rem',
      outline: 'none',
      transition: 'all 0.2s ease',
      backgroundColor: '#ffffff',
      boxSizing: 'border-box',
    },
    inputFocus: {
      borderColor: '#4d4d4d',
      boxShadow: '0 0 0 2px rgba(25, 118, 210, 0.1)',
    },
    inputError: {
      borderColor: '#dc2626',
      boxShadow: '0 0 0 2px rgba(220, 38, 38, 0.1)',
    },
    inputDisabled: {
      backgroundColor: '#f8fafc',
      color: '#64748b',
      cursor: 'not-allowed',
    },
    btnPrimary: {
      backgroundColor: '#4d4d4d',
      color: '#ffffff',
    },
    btnOutline: {
      backgroundColor: '#ffffff',
      color: '#4d4d4d',
      border: '1px solid #4d4d4d',
    },
    btnDanger: {
      backgroundColor: '#dc2626',
      color: '#ffffff',
    },
    btnActions: {
      display: 'flex',
      gap: '8px',
      justifyContent: 'flex-end',
      paddingTop: '16px',
      borderTop: '1px solid #e2e8f0',
      marginTop: '24px',
    },
    helperText: {
      color: '#64748b',
      fontSize: '0.7rem',
      marginTop: '2px',
    },
    loadingOverlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 9999,
    },
    spinner: {
      width: '40px',
      height: '40px',
      border: '4px solid #e2e8f0',
      borderTop: '4px solid #4d4d4d',
      borderRadius: '50%',
      animation: 'spin 1s linear infinite',
    },
    productInfo: {
      backgroundColor: '#f8fafc',
      padding: '12px',
      borderRadius: '6px',
      border: '1px solid #e2e8f0',
      marginTop: '16px',
    },
    infoRow: {
      display: 'flex',
      alignItems: 'center',
      padding: '6px 0',
      borderBottom: '1px solid #e2e8f0',
      position: 'relative',
    },
    infoLabel: {
      fontSize: '0.75rem',
      color: '#64748b',
      fontWeight: 500,
      width: '35%', // Fixed width for labels
      flexShrink: 0,
    },
    divider: {
      width: '1px',
      height: '16px',
      backgroundColor: '#cbd5e1',
      margin: '0 12px',
    },
    infoValue: {
      fontSize: '0.8rem',
      color: '#1e293b',
      fontWeight: 500,
      flex: 1,
      paddingLeft: '12px',
    },
  };

  const handleitemname = (event, value) => {
    if (value && typeof value === 'object') {
      setName(value.name);
      setUom(value.uomname);
      setFilterlist(value);
    } else {
      setName('');
      setUom('');
      setFilterlist('');
    }
  };

  const onSubmit = (values) => {
    setLoader(true);
    const selectedItemId = filterlist?.id;

    let addcost = {
      id: selectedItemId,
      rate: values.cost,
      createdby: userid,
      tenantid: currentTenant
    };

    let updatecost = {
      id: values.id,
      cid: id,
      name: values.name,
      rate: values.cost,
      updatedby: userid,
      tenantid: currentTenant
    };

    if (!id || id < 1) {
      InventoryService.addCost(addcost)
        .then(() => {
          setLoader(false);
          Swal.fire({
            title: `Cost added successfully`,
            text: ".",
            icon: "success",
            confirmButtonText: "Ok",
            confirmButtonColor: "#152f5f",
          }).then(() => navigate('/cost'));
        })
        .catch((e) => {
          setLoader(false);
          if (e.response?.data?.error === "Unauthorized") {
            Swal.fire({
              title: `Your Session is Lost: Please login Back to resume`,
              text: ".",
              icon: "error",
              confirmButtonText: "Ok",
              confirmButtonColor: "#152f5f",
            }).then(() => navigate('/'));
          } else {
            Swal.fire({
              title: `${e.response.data.message}`,
              text: ".",
              icon: "error",
              confirmButtonText: "Ok",
              confirmButtonColor: "#152f5f",
            });
          }
        });
    } else {
      InventoryService.updateCost(updatecost)
        .then(() => {
          setLoader(false);
          Swal.fire({
            title: `Cost updated successfully`,
            text: ".",
            icon: "success",
            confirmButtonText: "Ok",
            confirmButtonColor: "#152f5f",
          }).then(() => navigate('/cost'));
        })
        .catch((e) => {
          setLoader(false);
          if (e.response?.data?.error === "Unauthorized") {
            Swal.fire({
              title: `Your Session is Lost: Please login Back to resume`,
              text: ".",
              icon: "error",
              confirmButtonText: "Ok",
              confirmButtonColor: "#152f5f",
            }).then(() => navigate('/'));
          } else {
            Swal.fire({
              title: `${e.response.data.message}`,
              text: ".",
              icon: "error",
              confirmButtonText: "Ok",
              confirmButtonColor: "#152f5f",
            });
          }
        });
    }
  };

  const onfocus = () => {
    const priceInput = document.getElementById('price');
    if (priceInput) {
      priceInput.addEventListener('mousewheel', function (event) {
        if (window.document.activeElement.type === 'number') {
          event.preventDefault();
        }
      });
      priceInput.addEventListener('keydown', function (e) {
        if (e.which === 38 || e.which === 40) {
          e.preventDefault();
        }
      });
    }
  };

  useEffect(() => {
    if (!userid) {
      Swal.fire({
        title: "Session Expired",
        text: "Your Session is Lost: Please login Back to resume",
        icon: "warning",
        confirmButtonText: "Ok",
        confirmButtonColor: "#152f5f",
      }).then(() => navigate('/'));
      return;
    }

    // Load items
    InventoryService.retriveAllItems(currentTenant)
      .then((response) => setItemsList(response.data))
      .catch((e) => {
        if (e.response?.data?.error === "Unauthorized") {
          Swal.fire({
            title: "Session Expired",
            text: "Your Session is Lost: Please login Back to resume",
            icon: "error",
            confirmButtonText: "Ok",
            confirmButtonColor: "#152f5f",
          }).then(() => navigate('/'));
        }
      });

    // If editing, load cost data
    if (id > 0) {
      InventoryService.costData(id)
        .then(response => {
          setName(response.data.name);
          setCost(response.data.rate);
          setUom(response.data.uomname);
          setFilterlist(response.data);
        });
    }

    // Auto-fill item from navigation state if present
    if (location.state?.item) {
      const itm = location.state.item;
      setName(itm.name);
      setUom(itm.uomname);
      setFilterlist(itm);

      // Auto-focus the price input
      setTimeout(() => {
        const priceInput = document.getElementById('price');
        if (priceInput) {
          priceInput.focus();
        }
      }, 100);
    }
  }, [id, navigate, location.state]);

  const validate = (values) => {
    let errors = {};

    if (!values.name || values.name === '') {
      errors.name = "Please Select An Item";
    }
    if (!values.cost) {
      errors.cost = 'Price can not be empty';
    }
    if (values.cost < 0) {
      errors.cost = 'Price Should be greater than 0';
    }

    return errors;
  };

  return (
    <div className="UI-container">
      {/* Loading Overlay */}
      {loader && (
        <div style={styles.loadingOverlay}>
          <div style={styles.spinner}></div>
        </div>
      )}

      <div className="UI-card">
        <div className="UI-header">
        <Breadcrumb breadcrumbs={[{name:"Home",path:"/inventory"},{name:"Item Price",path:"/cost"},{name:pagename,path:null}]}/>

          <div className="UI-header-content">
            <div>
              <h1 className="UI-title">{pagename}</h1>
              <p className="UI-subtitle">
                {id < 1 ? 'Add new price information' : 'Update existing price'}
              </p>
            </div>
            <div className="UI-header-actions">
              <Link
                to="/cost"
                style={{
                  ...styles.btnOutline, display: 'inline-flex',
                  alignItems: 'center',
                  gap: '6px',
                  padding: '6px 12px',
                  borderRadius: '6px',
                  border: 'none',
                  fontSize: '0.8rem',
                  fontWeight: 500,
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                  textDecoration: 'none',
                  minHeight: '32px',
                  backgroundColor: '#ffffff',
                  color: '#4d4d4d',
                  border: '1px solid #4d4d4d',
                }}
              >
                ← Back
              </Link>
            </div>
          </div>
        </div>

        <div className="UI-form-container">
          <Formik
            initialValues={{ id: id, name: name, cost: cost }}
            onSubmit={onSubmit}
            validateOnChange={false}
            validate={validate}
            enableReinitialize={true}
          >
            {({ values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting, setFieldValue }) => (
              <Form onSubmit={handleSubmit}>
                <div className="UI-form-section">
                  <h3 className="UI-section-title" style={{ borderBottom: '1px solid #e2e8f0', paddingBottom: '6px' }}>Price Information</h3>
                  <div className="UI-form-grid">
                    {pagename === "Edit Price" ? (
                      <div style={styles.formGroup}>
                        <label style={styles.label}>Item Name</label>
                        <input
                          type="text"
                          name="name"
                          value={name}
                          style={{
                            ...styles.input,
                            ...styles.inputDisabled
                          }}
                          disabled
                          placeholder="Item name"
                        />
                      </div>
                    ) : (
                      <div style={styles.formGroup}>
                        <label style={styles.label}>Select Item *</label>

                        <Autocomplete
                          options={itemsList}
                          value={filterlist || null}
                          isOptionEqualToValue={(option, value) => option.id === value.id}
                          getOptionLabel={(option) => option.name || ""}
                          onChange={handleitemname}
                          renderOption={(props, option) => (
                            <li {...props} style={{ display: "flex", justifyContent: "space-between" }}>
                              <span>{option.name}</span>
                              {option.cost && (
                                <span style={{ opacity: 0.7 }}>{option.cost} {currency}</span>
                              )}
                            </li>
                          )}
                          renderInput={(params) => (
                            <div ref={params.InputProps.ref}>
                              <input
                                type="text"
                                {...params.inputProps}
                                style={{
                                  ...styles.input,
                                  ...(errors.name && touched.name ? styles.inputError : {})
                                }}
                                placeholder="Select an item"
                              />
                            </div>
                          )}
                        />

                        {errors.name && touched.name && (
                          <div className="UI-error-text">{errors.name}</div>
                        )}
                      </div>

                    )}

                    <div style={styles.formGroup}>
                      <TextfieldComponent
                        id="price"
                        type="number"
                        label={`Price per ${uom}`}
                        name="cost"
                        value={values.cost}
                        onChange={handleChange}
                        onFocus={onfocus}
                        style={{
                          ...styles.input,
                          ...(errors.cost && touched.cost ? styles.inputError : {})
                        }}
                        placeholder={`Enter price per ${uom}`}
                        error={errors.cost && touched.cost ? errors.cost : ''}
                      />
                    </div>
                  </div>

                  {filterlist && (
                    <div style={styles.productInfo}>
                      <div style={styles.infoRow}>
                        <span style={styles.infoLabel}>Brand</span>
                        <div style={styles.divider}></div>
                        <span style={styles.infoValue}>{filterlist.brand || 'N/A'}</span>
                      </div>
                      <div style={styles.infoRow}>
                        <span style={styles.infoLabel}>Model</span>
                        <div style={styles.divider}></div>
                        <span style={styles.infoValue}>{filterlist.model || 'N/A'}</span>
                      </div>
                      <div style={{ ...styles.infoRow, borderBottom: 'none' }}>
                        <span style={styles.infoLabel}>Specifications</span>
                        <div style={styles.divider}></div>
                        <span style={styles.infoValue}>{filterlist.description || 'N/A'}</span>
                      </div>
                    </div>
                  )}

                  <div style={styles.helperText}>
                    Note: Price must be Exclusive of tax.
                  </div>
                </div>

                <div style={styles.btnActions}>
                  <Link
                    to="/cost"
                    style={{
                      ...styles.btnOutline, display: 'inline-flex',
                      alignItems: 'center',
                      gap: '6px',
                      padding: '6px 12px',
                      borderRadius: '6px',
                      border: 'none',
                      fontSize: '0.8rem',
                      fontWeight: 500,
                      cursor: 'pointer',
                      transition: 'all 0.2s ease',
                      textDecoration: 'none',
                      minHeight: '32px',
                      backgroundColor: '#ffffff',
                      color: '#4d4d4d',
                      border: '1px solid #4d4d4d',
                    }}
                  >
                    Cancel
                  </Link>
                  <button
                    type="submit"
                    disabled={isSubmitting || loader}
                    style={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: '6px',
                      padding: '6px 12px',
                      borderRadius: '6px',
                      border: 'none',
                      fontSize: '0.8rem',
                      fontWeight: 500,
                      cursor: 'pointer',
                      transition: 'all 0.2s ease',
                      textDecoration: 'none',
                      minHeight: '32px',
                      backgroundColor: '#4d4d4d',
                      color: '#ffffff',
                      opacity: (isSubmitting || loader) ? 0.6 : 1
                    }}
                  >
                    {loader ? 'Saving...' : 'Save'}
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
};

export default withRouter(AddCost);